import { useState } from 'react';

import { ComponentActions } from '../components.style';
import ActivityBuilderInlineSvg from 'approot/shared/inline-svg/activity-builder/activity-builder-inline-svg';
import { ViewProps } from './draw.constants';
import * as Styled from './draw-print.style';
import SubActivityPrint from '../sub-activity/sub-activity-print';
import { getPrintImage } from '../shared/logic/get-print-image';
import DrawPrintAnswersCanvasWrapper from './draw-print-answers-canvas';
import { LanguageCodes } from 'global/constants';

type Props = ViewProps & {
  language: LanguageCodes;
  hideControls?: boolean;
  onRenderComplete?: () => void;
};

const DrawPrint = (props: Props) => {
  const [previewRef, setPreviewRef] = useState<HTMLDivElement | null>(null);

  const paddingTop =
    (props.properties.dimensionData.height /
      props.properties.dimensionData.width) *
    100;

  return (
    <SubActivityPrint subActivityDetails={props.subActivityProperties}>
      <div ref={setPreviewRef}>
        <Styled.DrawPrint
          style={{
            paddingTop: `${paddingTop}%`,
          }}
        >
          {props.hideControls ? null : (
            <ComponentActions>
              <Styled.DrawPrintButton>
                <ActivityBuilderInlineSvg
                  id="icon_pencil"
                  width={24}
                  height={24}
                />
              </Styled.DrawPrintButton>
            </ComponentActions>
          )}
          <Styled.DrawPrintImage>
            {previewRef && (
              <DrawPrintAnswersCanvasWrapper
                key={props.id}
                id={`print-${props.id}`}
                language={props.language}
                imageUrl={getPrintImage(
                  props.properties.image?.responsive || []
                )}
                dimensionsData={props.properties.dimensionData}
                containerEl={previewRef}
                questionData={props.properties.draw || undefined}
                onRenderComplete={() => props.onRenderComplete?.()}
              />
            )}
          </Styled.DrawPrintImage>
        </Styled.DrawPrint>
      </div>
    </SubActivityPrint>
  );
};

export default DrawPrint;
